import{a as c}from"./chunk-XNWTUBQ2.js";import{a as r,b as o,m as t}from"./chunk-HBP5N4FR.js";t();function f(i){var a;try{let n=i,s=c(o(r({},n),{chainID:(a=n.chainID)!=null?a:"D"}));return Boolean(s)}catch(n){return!1}}export{f as a};
//# sourceMappingURL=chunk-JRI3Z4WO.js.map
